<div class="card-box">
  <kendo-tabstrip #tabstrip="kendoTabStrip" class="nav-bordered">

    <kendo-tabstrip-tab [title]="'Impressoras'"   [selected]="true">
      <ng-template kendoTabTitle>
        <i class="fas fa-print mr-2"></i>
        Impressoras
      </ng-template>
      <ng-template kendoTabContent>
        <app-config-impressao [empresa]="empresa" [possuiModuloFiscal]="possuiModuloFiscal"
                              [possuiRecursoImpressaoAutomatica]="possuiRecursoImpressaoAutomatica" ></app-config-impressao>
      </ng-template>

    </kendo-tabstrip-tab>

    <kendo-tabstrip-tab [title]="'Kds'"  *ngIf="possuiModuloKDS"  >
      <ng-template kendoTabTitle>
        <i class="fa fa-desktop mr-2"></i>
        Areas de Destino KDS
      </ng-template>
      <ng-template kendoTabContent>

        <div class="row mb-3">
          <div class="col-12 text-right">
            <button class="btn btn-primary" (click)="novo()">
              <i class="fa fa-plus"></i> Nova Área
            </button>
          </div>
        </div>

        <kendo-grid [data]="areas" [loading]="carregando">
          <kendo-grid-column field="nome" title="Nome"></kendo-grid-column>
          <kendo-grid-column field="comissionado.nome" title="Comissionado / confeiteiro"></kendo-grid-column>
          <kendo-grid-column field="envioAutomatico" title="Envio Automático" [width]="200">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span class="badge badge-success" *ngIf="dataItem.comissionado">Automático por confeiteiro</span>
              <span class="badge badge-success" *ngIf="!dataItem.comissionado && dataItem.envioAutomatico">Sim</span>
              <span class="badge badge-secondary" *ngIf="!dataItem.comissionado && !dataItem.envioAutomatico">Não</span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="categorias" title="Categorias Associadas">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span *ngIf="dataItem.comissionado" class="text-muted small">Pela atribuição do item</span>
              <ng-container *ngIf="!dataItem.envioAutomatico && !dataItem.comissionado">
                 <span *ngFor="let cat of dataItem.categorias" class="badge badge-info mr-1" style="font-size: 0.85em;">{{ cat.nome }}</span>
                 <span *ngIf="!dataItem.categorias || dataItem.categorias.length === 0" class="text-muted small">Nenhuma</span>
              </ng-container>
              <span *ngIf="dataItem.envioAutomatico && !dataItem.comissionado" class="text-muted small">Todas (Automático)</span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="etapas" title="Etapas" [width]="80">
             <ng-template kendoGridCellTemplate let-dataItem>
               {{ dataItem.etapas ? dataItem.etapas.length : 0 }}
             </ng-template>
          </kendo-grid-column>
          <kendo-grid-command-column title="Ações" [width]="150">
            <ng-template kendoGridCellTemplate let-dataItem>
              <button kendoGridEditCommand [primary]="true" icon="edit" (click)="editar(dataItem)"></button>
              <button kendoGridRemoveCommand icon="delete" (click)="remover(dataItem)"></button>
            </ng-template>
          </kendo-grid-command-column>
        </kendo-grid>

      </ng-template>

    </kendo-tabstrip-tab>

  </kendo-tabstrip>
</div>

<kendo-dialog *ngIf="exibirFormulario" [minWidth]="500" [width]="700" (close)="onCancelado()"
              title=" {{ areaEmEdicao ? 'Editar Área de Destino' : 'Nova Área de Destino' }}">
  <div class="p-3">
    <app-cad-area-destino [area]="areaEmEdicao" (salvo)="onSalvo($event)" (cancelado)="onCancelado()"></app-cad-area-destino>
  </div>
</kendo-dialog>
